var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5828 11.4435C27.6263 7.40535 34.7316 5.25 42 5.25C51.7467 5.25 61.0942 9.12186 67.9862 16.0138C74.8782 22.9058 78.75 32.2533 78.75 42C78.75 49.2685 76.5947 56.3737 72.5565 62.4172C68.5184 68.4607 62.7788 73.1711 56.0636 75.9526C49.3484 78.7341 41.9593 79.4619 34.8304 78.0439C27.7016 76.6258 21.1534 73.1258 16.0138 67.9862C10.8743 62.8466 7.37416 56.2984 5.95616 49.1696C4.53815 42.0408 5.26592 34.6516 8.04744 27.9364C10.829 21.2212 15.5393 15.4816 21.5828 11.4435ZM24.4996 68.1913C29.6797 71.6526 35.7699 73.5 42 73.5C50.3543 73.5 58.3665 70.1813 64.2739 64.2739C70.1813 58.3665 73.5 50.3543 73.5 42C73.5 35.7699 71.6526 29.6797 68.1913 24.4995C64.73 19.3194 59.8104 15.282 54.0545 12.8978C48.2987 10.5136 41.9651 9.88983 35.8547 11.1053C29.7443 12.3207 24.1315 15.3208 19.7262 19.7261C15.3208 24.1315 12.3207 29.7443 11.1053 35.8547C9.88985 41.9651 10.5137 48.2987 12.8978 54.0545C15.282 59.8104 19.3194 64.73 24.4996 68.1913ZM23.625 43.0841L36.75 56.2118L60.375 32.5894L56.6606 28.875L36.75 48.7882L27.3341 39.375L23.625 43.0841Z",
    fill: "#59872C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkOutline);
export default __webpack_public_path__ + "static/media/checkmark_outline.7ea197d8a78dbd347d6e037b9c1200c8.svg";
export { ForwardRef as ReactComponent };